import BulletList from "@tiptap/extension-bullet-list";

/**
 * BulletList with a `dashed` flag so a bulleted list can render with dash
 * markers instead of discs. Persisted as `class="list-dashed"` on the <ul> and
 * parsed back, so it round-trips through the read-only editor's schema (only
 * this controlled class survives — arbitrary classes are dropped).
 */
export const DashedBulletList = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      dashed: {
        default: false,
        parseHTML: (element) => element.classList.contains("list-dashed"),
        renderHTML: (attributes) =>
          attributes.dashed ? { class: "list-dashed" } : {},
      },
    };
  },
});
